import { ImageNameEnum as i } from "../image-enum.mjs";
const n = (e) => e ? e.isActive(i.Block) || e.isActive(i.Inline) : !1;
export {
  n as isImageSelected
};
